// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".e-input-datetime__card .v-picker{border-radius:0!important}.e-input-datetime__card .v-picker__title{height:auto}.e-input-datetime__card .v-picker .v-date-picker-title__date{font-size:1.25rem}.e-input-datetime__select{max-width:280px;display:block;margin:0 auto}", ""]);
// Exports
module.exports = exports;
